export default {
    getTaggingItem: ({taggingItem}) => taggingItem,

    isTaggingActive: ({isTaggingActive}) => isTaggingActive,
    isLoading: ({isLoading}) => isLoading,

    getClientId: ({clientId}) => clientId,
    getDeviceInfo: ({device}) => device,
    getClientInfo: ({clientInfo}) => clientInfo,
};